import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './StandardOverview.module.css';
import { OverviewTextAction } from './OverviewCardShell';
import { OVERVIEW_DUMMY_FIELDS } from './overviewDummyFields';
import { buildOperationalSummaries } from '../../../utils/operationalOverviewSummaries';

const DeliveryRow = ({ title, lines, actionLabel, onAction, dangerLineIndex = 0 }) => (
    <div className={styles.deliveryRow}>
        <div>
            <p className={styles.deliveryRowTitle}>{title}</p>
            {lines.map((line, index) => (
                <p
                    key={line}
                    className={index === dangerLineIndex ? styles.deliveryRowDanger : styles.deliveryRowMeta}>
                    {line}
                </p>
            ))}
        </div>
        <OverviewTextAction onClick={onAction}>{actionLabel}</OverviewTextAction>
    </div>
);

const DeliveryGovernanceCard = ({ model }) => {
    const navigate = useNavigate();
    const { delivery, features } = model;
    const summaries = useMemo(() => buildOperationalSummaries(model), [model]);
    const tasksEmpty = summaries.tasks === 'No tasks yet';
    const raidEmpty = summaries.raid === 'No RAID items';
    const actionLogEmpty = summaries.actionLog === 'No actions';

    if (!features?.deliveryGovernance) {
        return null;
    }

    const showTasks = features.projectManagement;
    const showRaid = features.raidLog;
    const showAction = features.actionLog;
    if (!showTasks && !showRaid && !showAction) {
        return null;
    }

    return (
        <section className={styles.deliveryCard}>
            <p className={styles.cardEyebrow}>Delivery &amp; Governance</p>
            {showTasks ? (
                <DeliveryRow
                    title="Tasks"
                    lines={tasksEmpty ? ['No tasks yet'] : delivery.tasks.lines}
                    actionLabel="Open Tasks →"
                    onAction={() => navigate('/tasks')}
                    dangerLineIndex={tasksEmpty ? -1 : 0}
                />
            ) : null}
            {showRaid ? (
                <DeliveryRow
                    title="RAID"
                    lines={raidEmpty ? ['No RAID items'] : delivery.raid.lines}
                    actionLabel="Open RAID →"
                    onAction={() => navigate('/raid')}
                    dangerLineIndex={-1}
                />
            ) : null}
            {showAction ? (
                <DeliveryRow
                    title="Action Log"
                    lines={actionLogEmpty ? ['No actions'] : delivery.actionLog.lines}
                    actionLabel="Open Action Log →"
                    onAction={() => navigate('/action-log')}
                    dangerLineIndex={actionLogEmpty ? -1 : 0}
                />
            ) : null}
            <span className={styles.visuallyHidden} title={OVERVIEW_DUMMY_FIELDS.raidHighPriorityCount} />
        </section>
    );
};

export default DeliveryGovernanceCard;
